/* eslint-disable */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@wix/ambassador/runtime/http");
exports.WishlistServer = function (baseUrl) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl);
    return {
        Wishlist: function () {
            return function (headers) {
                var service = {
                    addToWishlist: function (addToWishlistRequest) {
                        return httpClient.invoke('POST', '/v1/wishlist/my', addToWishlistRequest, headers);
                    },
                    getWishlist: function (getWishlistRequest) {
                        return httpClient.invoke('GET', '/v1/wishlist/my', getWishlistRequest, headers);
                    },
                    removeFromWishlist: function (removeFromWishlistRequest) {
                        return httpClient.invoke('POST', '/v1/wishlist/my/removeItems', removeFromWishlistRequest, headers);
                    }
                };
                service.addToWishlist.__http_method = 'POST';
                service.addToWishlist.__http_url = '/v1/wishlist/my';
                service.getWishlist.__http_method = 'GET';
                service.getWishlist.__http_url = '/v1/wishlist/my';
                service.removeFromWishlist.__http_method = 'POST';
                service.removeFromWishlist.__http_url = '/v1/wishlist/my/removeItems';
                return service;
            };
        }
    };
};
exports.WishlistServer.__transport = 'http';
__export(require("./types"));
